"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "var(--sds--ursa-icons--background-color, transparent)",
  d: "M4 8.307c0-1.03.835-1.866 1.865-1.866h4.322v3.73H5.865A1.865 1.865 0 0 1 4 8.308m3 7.402c0-1.015.823-1.838 1.839-1.838h1.225v3.678H8.839A1.84 1.84 0 0 1 7 15.71m10-7.385A1.825 1.825 0 0 0 15.175 6.5h-1.25v3.65h1.25A1.825 1.825 0 0 0 17 8.325m3.5 7.358a1.85 1.85 0 0 0-1.85-1.85h-4.84v3.7h4.84a1.85 1.85 0 0 0 1.85-1.85"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M18.8 14.544a.8.8 0 0 1 .8.8v.69a.8.8 0 0 1-.8.8h-4.294a.7.7 0 1 0 0 1.4H18.8a2.2 2.2 0 0 0 2.2-2.2v-.69a2.2 2.2 0 0 0-2.2-2.2h-4.294a.7.7 0 1 0 0 1.4zm-8.722-.7a.7.7 0 0 0-.7-.7h-.95a2.2 2.2 0 0 0-2.2 2.2v.69a2.2 2.2 0 0 0 2.2 2.2h.95a.7.7 0 1 0 0-1.4h-.95a.8.8 0 0 1-.8-.8v-.69a.8.8 0 0 1 .8-.8h.95a.7.7 0 0 0 .7-.7m5.494-6.677a.8.8 0 0 1 .8.8v.689a.8.8 0 0 1-.8.8h-.95a.7.7 0 0 0 0 1.4h.95a2.2 2.2 0 0 0 2.2-2.2v-.69a2.2 2.2 0 0 0-2.2-2.2h-.95a.7.7 0 1 0 0 1.4zm-5.378-.7a.7.7 0 0 0-.7-.7H5.2a2.2 2.2 0 0 0-2.2 2.2v.689a2.2 2.2 0 0 0 2.2 2.2h4.294a.7.7 0 0 0 0-1.4H5.2a.8.8 0 0 1-.8-.8v-.69a.8.8 0 0 1 .8-.8h4.294a.7.7 0 0 0 .7-.7M12 3a.7.7 0 0 0-.7.7v16.6a.7.7 0 1 0 1.4 0V3.7A.7.7 0 0 0 12 3",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=TimelineIcon24.js.map